import {
  MapTemplatesContainer, type MapTemplatesProps,
} from '~/map/mapTemplatesModal/mapTemplatesModal.container';
import { modalRenderer } from '~/modal/modalRendererRegistry';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    MapTemplates: MapTemplatesProps;
  }
}
modalRenderer.register('MapTemplates', MapTemplatesContainer);
